import Grid from "@mui/material/Grid";
import { formatAmount } from "../../../Utility/Utilitys";
import {
  CmpTypographyField,
  CmpInputField,
  CmpButton,
  CmpStatus,
} from "../../../Component/Common/ToolBox/ToolBox";
export default function WmsFooter({
  HeadObject,
  fDetailSave,
  fP_Value,
  fSelectAll,
}) {
  return (
    <div className="Wms-footer">
      {" "}
      <Grid
        container
        rowSpacing={{ xs: 0.5, sm: 0.9, md: 0 }}
        columnSpacing={{ xs: 2, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        className="align-items-center justify-content-around"
      >
        <Grid item xs={8} sm={8} md={2} lg={2}>
          {/* <button
            className={
              HeadObject?.A_DocStat === "ENTER"
                ? "btn px-3  py-0 btn-warning"
                : HeadObject?.A_DocStat === "POST"
                ? "btn px-3  py-0 btn-success"
                : HeadObject?.A_DocStat === "DELETE"
                ? "btn px-3  py-0 btn-danger"
                : HeadObject?.A_DocStat === "DRAFT"
                ? "btn px-3  py-0 btn-secondary"
                : "btn px-3 btn-primary"
            }
            // className="hide-all-time"
          >
            <span> STATUS = </span>
            <span>{HeadObject?.A_DocStat}</span>
          </button> */}
          <CmpStatus xStatus={HeadObject.A_DocStat} />
        </Grid>
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpButton
            xbtnName="Save"
            xOnClick={fDetailSave}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>{" "}
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpButton
            xbtnName="P1"
            xOnClick={() => {
              fP_Value("P1");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>{" "}
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpButton
            xbtnName="P2"
            xOnClick={() => {
              fP_Value("P2");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>{" "}
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpButton
            xbtnName="New Items"
            xOnClick={() => {
              fP_Value("P3");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpButton
            xbtnName="Select All"
            xOnClick={() => {
              fSelectAll("Y");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpButton
            xbtnName="De-Select All"
            xOnClick={() => {
              fSelectAll("N");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpButton
            xbtnName="Inverse"
            xOnClick={() => {
              fSelectAll("Inverse");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpTypographyField xcomponent={"div"} xText={"Total Value"} />
        </Grid>
        <Grid item xs={4} sm={4} md={1} lg={1}>
          <CmpInputField
            xValue={formatAmount(HeadObject?.A_Total_Val)}
            xType={"text"} // text/number/password
            xName={"A_Total_Val"}
            xReadOnly={true}
            // xOnChange={fA_Total_Val}
            xError={false}
            xErrorMessage={""}
            xTextAlign="right"
          />
        </Grid>
      </Grid>
    </div>
  );
}
